import { DoctorService } from '@/services/doctor.service';
import SourceDoctorSelector from './SourceDoctorSelector.vue';
import DateControls from './DateControls.vue';
import SourceStateList from './SourceStateList.vue';
import RecipientDoctorList from './RecipientDoctorList.vue';
import TransferSummaryBar from './TransferSummaryBar.vue';
import ConfirmTransferDialog from './ConfirmTransferDialog.vue';
export default {
  components: {
    SourceDoctorSelector,
    DateControls,
    SourceStateList,
    RecipientDoctorList,
    TransferSummaryBar,
    ConfirmTransferDialog
  },
  data() {
    return {
      showDialog: false,
      alert: {
        show: false,
        message: ''
      },
      reassignmentType: 'TEMPORARY',
      reassignmentTypeOptions: [{
        text: 'Temporary',
        value: 'TEMPORARY'
      }, {
        text: 'Permanent',
        value: 'PERMANENT'
      }],
      reasonCategory: null,
      reasonDetails: '',
      reasonCategoryOptions: [{
        text: 'Select a reason',
        value: null,
        disabled: true
      }, {
        text: 'License Expiration',
        value: 'License Expiration'
      }, {
        text: 'Doctor Offboarding',
        value: 'Doctor Offboarding'
      }, {
        text: 'Panel Rebalancing',
        value: 'Panel Rebalancing'
      }, {
        text: 'Other',
        value: 'Other'
      }],
      sourceDoctor: null,
      panelSummary: null,
      loadingPanelSummary: false,
      panelSummaryVersion: 0,
      selectedStates: [],
      statePatientCounts: [],
      recipientIds: [],
      receivingDoctors: [],
      includePatients: 'ALL',
      totalDistributed: 0,
      totalIncluded: 0,
      startTimestamp: null,
      endTimestamp: null,
      reduceByMode: 'COUNT',
      reduceByAmount: 0,
      reduceTargetCount: 0,
      weightByLoad: true,
      footerCaption: '',
      distributionComplete: false,
      submitting: false
    };
  },
  computed: {
    datesValid() {
      if (!this.startTimestamp) {
        return false;
      }
      if (this.reassignmentType === 'TEMPORARY' && !this.endTimestamp) {
        return false;
      }
      return true;
    },
    canSubmit() {
      return !!this.sourceDoctor && this.selectedStates.length > 0 && this.recipientIds.length > 0 && this.datesValid && this.distributionComplete && !!this.reasonCategory && (this.reasonCategory !== 'Other' || !!this.reasonDetails);
    },
    sourcePanelTotal() {
      var _this$panelSummary, _this$panelSummary$so;
      return ((_this$panelSummary = this.panelSummary) === null || _this$panelSummary === void 0 ? void 0 : (_this$panelSummary$so = _this$panelSummary.source) === null || _this$panelSummary$so === void 0 ? void 0 : _this$panelSummary$so.total) || 0;
    },
    sourceDoctorLabel() {
      return this.sourceDoctor ? `Dr. ${this.sourceDoctor.firstname} ${this.sourceDoctor.lastname}` : '';
    },
    reasonLabel() {
      if (!this.reasonCategory) {
        return '';
      }
      if (this.reasonCategory === 'Other') {
        return `Other - ${this.reasonDetails}`;
      }
      return this.reasonCategory;
    },
    submitBody() {
      var _this$sourceDoctor;
      return {
        reassignmentType: this.reassignmentType,
        schedule: {
          startDate: String(this.startTimestamp),
          ...(this.reassignmentType === 'TEMPORARY' && {
            endDate: String(this.endTimestamp)
          })
        },
        reason: {
          category: this.reasonCategory,
          details: this.reasonCategory === 'Other' ? this.reasonDetails : null
        },
        sourceDoctorId: (_this$sourceDoctor = this.sourceDoctor) === null || _this$sourceDoctor === void 0 ? void 0 : _this$sourceDoctor.id,
        distributionConfig: {
          selectedStates: this.selectedStates,
          includePatients: this.mapIncludePatients(this.includePatients),
          reduceBy: {
            mode: this.reduceByMode === 'PERCENT' ? 'percent' : 'count',
            amount: this.reduceByAmount
          },
          perDoctorCap: 0,
          weightByCurrentLoad: this.weightByLoad
        },
        receivingDoctors: this.receivingDoctors
      };
    }
  },
  watch: {
    reasonCategory(val, oldVal) {
      if (val === 'Other') {
        this.$nextTick(() => {
          var _this$$refs$reasonDet;
          return (_this$$refs$reasonDet = this.$refs.reasonDetailsInput) === null || _this$$refs$reasonDet === void 0 ? void 0 : _this$$refs$reasonDet.focus();
        });
      } else if (oldVal === 'Other') {
        this.reasonDetails = '';
      }
    },
    showDialog(show) {
      if (show) {
        return;
      }
      this.reassignmentType = 'TEMPORARY';
      this.reasonCategory = null;
      this.reasonDetails = '';
      this.sourceDoctor = null;
      this.panelSummary = null;
      this.loadingPanelSummary = false;
      this.panelSummaryVersion += 1;
      this.selectedStates = [];
      this.statePatientCounts = [];
      this.recipientIds = [];
      this.receivingDoctors = [];
      this.includePatients = 'ALL';
      this.totalDistributed = 0;
      this.totalIncluded = 0;
      this.startTimestamp = null;
      this.endTimestamp = null;
      this.reduceByMode = 'COUNT';
      this.reduceByAmount = 0;
      this.reduceTargetCount = 0;
      this.weightByLoad = true;
      this.footerCaption = '';
      this.distributionComplete = false;
      this.alert = {
        show: false,
        message: ''
      };
    }
  },
  methods: {
    onChildError(message) {
      this.alert = {
        show: true,
        message
      };
    },
    async onSourceDoctorSelect(doctor) {
      this.sourceDoctor = doctor;
      this.panelSummary = null;
      if (!doctor) {
        return;
      }
      const version = ++this.panelSummaryVersion;
      try {
        this.loadingPanelSummary = true;
        const {
          data
        } = await DoctorService.getAdhocPanelSummary(doctor.id);
        if (version !== this.panelSummaryVersion) {
          return;
        }
        this.panelSummary = data.data;
      } catch {
        if (version !== this.panelSummaryVersion) {
          return;
        }
        this.onChildError('Failed to load doctor summary.');
      } finally {
        if (version === this.panelSummaryVersion) {
          this.loadingPanelSummary = false;
        }
      }
    },
    onDatesChange({
      startTimestamp,
      endTimestamp
    }) {
      this.startTimestamp = startTimestamp;
      this.endTimestamp = endTimestamp;
    },
    onStatesChange({
      states,
      stateCounts
    }) {
      this.selectedStates = states;
      this.statePatientCounts = stateCounts;
    },
    onRecipientChange({
      ids,
      totalDistributed,
      totalIncluded,
      includePatients,
      receivingDoctors,
      reduceByMode,
      reduceByAmount,
      reduceTargetCount,
      weightByLoad,
      footerCaption,
      distributionComplete
    }) {
      this.recipientIds = ids;
      this.totalDistributed = totalDistributed;
      this.totalIncluded = totalIncluded;
      this.includePatients = includePatients;
      this.receivingDoctors = receivingDoctors;
      this.reduceByMode = reduceByMode;
      this.reduceByAmount = reduceByAmount;
      this.reduceTargetCount = reduceTargetCount;
      this.weightByLoad = weightByLoad;
      this.footerCaption = footerCaption;
      this.distributionComplete = distributionComplete;
    },
    mapIncludePatients(value) {
      return value === 'ALL' ? 'all' : 'active';
    },
    openConfirmDialog() {
      this.$refs.ConfirmTransferDialog.showDialog = true;
    },
    onTransferConfirmed() {
      this.showDialog = false;
      this.$emit('show-toast', 'Reassignment created successfully!');
      this.$emit('refresh');
    }
  }
};